// import { generateUUID } from 'three/src/math/MathUtils';
import { nanoid } from 'nanoid';
export const nanoIdSize = 6; // Support upto 9 lacs
export function generateUniqueId(prefix: string) {
  return `${prefix}-` + nanoid(nanoIdSize);
  // return _uniqId(`${prefix}-`);
}
